<div class="container">
  <h2>Age Group Count Report</h2>

  <h4>Note : This report displays the count of children in age groups in two formats: Standard and Detailed. Use the 'Type' selector to view the counts in the chosen format.</h4>
  <mat-form-field appearance="outline">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
      <input matEndDate [(ngModel)]="endDate" placeholder="End date" (dateChange)="onEndDateChanged()" >
    </mat-date-range-input>
    <mat-hint>dd/MM/yyyy – dd/MM/yyyy</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>&nbsp; &nbsp;
  <mat-form-field appearance="outline">
    <mat-label>Type of Counts</mat-label>
    <mat-select [(value)]="type">
      <mat-option *ngFor="let type of types" [value]="type">{{ type }}</mat-option>
    </mat-select>
  </mat-form-field> &nbsp;
  <button mat-mini-fab (click)="search()"><mat-icon>search</mat-icon></button>
  <button class="mx-2" mat-mini-fab color="accent" (click)="Clear()"><mat-icon>clear</mat-icon></button>

  <div class="card p-2">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Unique Admission Counts</h2>
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <li>
          <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Age Group Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
            <img src="assets/images/icons/xlsx.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>

    <table class="table table-striped table-bordered" id="excel-table">
      <thead>
      <tr>
        <th scope="col" style="font-weight: bold;">Age Group</th>
        <th scope="col" *ngFor="let c of uniqueCentres" style="font-weight: bold;">{{ c }}</th>
        <th scope="col" style="font-weight: bold;">Total</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of uniqueAgeData">
        <td>{{ data.ageGroup }}</td>
        <ng-container *ngFor="let centre of data.centres">
          <td>{{ centre.count !== 0 ? centre.count : '-' }}</td>
        </ng-container>
        <td style="font-weight: bold;">{{ data.totalCount }}</td>
      </tr>
      <tr>
        <td><strong>Total</strong></td>
        <ng-container *ngFor="let total of totalColumns">
          <td><strong>{{ total }}</strong></td>
        </ng-container>
        <td><strong>{{ grandTotal }}</strong></td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="card p-2">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>FollowUp Admission Counts</h2>
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <li>
          <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel2()" permission="Age Group Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
            <img src="assets/images/icons/xlsx.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>

    <table class="table table-striped table-bordered" id="excel-table2">
      <thead>
      <tr>
        <th scope="col" style="font-weight: bold;">Age Group</th>
        <th scope="col" *ngFor="let c of uniqueCentres" style="font-weight: bold;">{{ c }}</th>
        <th scope="col" style="font-weight: bold;">Total</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of followUpAgeData">
        <td>{{ data.ageGroup }}</td>
        <ng-container *ngFor="let centre of data.centres">
          <td>{{ centre.count !== 0 ? centre.count : '-' }}</td>
        </ng-container>
        <td style="font-weight: bold;">{{ data.totalCount }}</td>
      </tr>
      <tr>
        <td><strong>Total</strong></td>
        <ng-container *ngFor="let total of followUpTotalColumns">
          <td><strong>{{ total }}</strong></td>
        </ng-container>
        <td><strong>{{ followUpGrandTotal }}</strong></td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
